"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;

var react_1 = __importDefault(require("react"));

var identity_1 = require("../../identity");

var utils_1 = require("../../utils");

var buttons_1 = require("../buttons");

var button_styles_1 = require("../buttons/button-styles");

var Link = function Link(_a) {
  var children = _a.children,
      href = _a.href,
      _b = _a.newWindow,
      newWindow = _b === void 0 ? false : _b,
      _c = _a.buttonLink,
      buttonLink = _c === void 0 ? false : _c,
      theme = _a.theme;
  var style = (theme ? theme.link.textColor + " hover:" + theme.link.hoverColor + " active:" + theme.link.activeColor + " visited:" + theme.link.visitedColor + " focus:" + theme.link.focusColor : "text-gray-800 hover:text-blue-800 active:text-blue-800 visited:text-blue-800 ") + " " + identity_1.defLink;

  if (newWindow) {
    return react_1["default"].createElement("button", {
      onClick: function onClick() {
        return (0, utils_1.openWindow)(href);
      },
      className: style
    }, children);
  } else if (buttonLink) {
    return react_1["default"].createElement("span", {
      className: (0, button_styles_1.buttonWrapper)(buttons_1.ButtonSize.normal)
    }, react_1["default"].createElement("button", {
      onClick: function onClick() {
        return newWindow ? (0, utils_1.openWindow)(href) : (0, utils_1.openUrl)(href);
      },
      type: "button",
      className: (0, button_styles_1.styleSpecial)(buttons_1.ButtonSize.normal)
    }, children));
  } else return react_1["default"].createElement("a", {
    href: href,
    className: style
  }, children);
};

exports.Link = Link;